module.exports = __webpack_public_path__ + "media/images/mobile/abouts/6-5936f9fc3a09ce5eb93e502e237002ca.jpg";